import { useState } from "react";
import { useHistory } from "react-router-dom";
import { Paginator } from "primereact/paginator";
import { parse, stringify } from "query-string";
import { Authorization } from "../../common/AuthorizationCpt";
import {
  BodyContainerTableCommon,
  ContainerBodyResponse,
  ContainerConfigurateCommon,
  ContainerGridColumnsTableCommon,
  ContainerScrollCommon,
  TableHeaderCommonResponsive,
} from "../../common/components/TableResponsive";
import { dateToRegularFormat } from "../../utils/dates";
import { ITEMS_PER_PAGE } from "../../utils/valueStaticConstants";
import AdminAppointmentConfigurationSidebar from "../AdminAppointmentConfigurationSidebar/AdminAppointmentConfigurationSidebar";
import { GrayDiv } from "./AdminAppointmentConfigurationStyled";
import { EditButton } from "../IconButtons";
import PaymentLoader from "../PaymentLoader/PaymentLoader";
import StandaloneMessage from "../StandaloneMessage/StandaloneMessage";
import { TimeslotsByDateConvert } from "./AdminAppointment.interface";

interface Props {
  loadAppointmentConfiguration: any;
  onTitleConfirmationChange: (title: string) => void;
  onMessageConfirmationChange: (message: string) => void;
  rangeConfirmation: () => void;
}
export const AdminAppointmentConfigurationTable = (props: Props) => {
  const {
    loadAppointmentConfiguration,
    onTitleConfirmationChange,
    onMessageConfirmationChange,
    rangeConfirmation,
  } = props;
  const gridTemplateColumnsSyncronize = "1fr 1fr 1fr 1fr";

  const [showSidebar, updateShowSidebar] = useState<boolean>(false);
  const [sidebarInfo, updateSidebarInfo] = useState<TimeslotsByDateConvert>();

  const handleClick = (newSidebarInfo: TimeslotsByDateConvert) => {
    updateSidebarInfo(newSidebarInfo);
    onTitleConfirmationChange("Parámetros de fecha de atención editados");
    onMessageConfirmationChange(
      "Se han editado los parámetros de fecha de atención exitosamente."
    );
    updateShowSidebar(true);
  };
  const history = useHistory();
  return (
    <div>
      {loadAppointmentConfiguration.isError && (
        <div>
          Algo salió mal
          <button
            type="button"
            onClick={() => {
              loadAppointmentConfiguration.retry();
            }}
          >
            Reintentar
          </button>
        </div>
      )}
      {loadAppointmentConfiguration.isSuccess &&
        loadAppointmentConfiguration.data.timeslots_by_date.length === 0 && (
          <StandaloneMessage>
            No se encontraron parámetros de citas a configurar.
          </StandaloneMessage>
        )}
      {loadAppointmentConfiguration.status === "PROCESSING" && (
        <>
          <PaymentLoader numItems={ITEMS_PER_PAGE} />
        </>
      )}
      <ContainerScrollCommon>
        <ContainerConfigurateCommon>
          <ContainerGridColumnsTableCommon
            gridTemplateColumns={gridTemplateColumnsSyncronize}
          >
            {loadAppointmentConfiguration.isSuccess &&
              loadAppointmentConfiguration.data.timeslots_by_date.length >
                0 && (
                <TableHeaderCommonResponsive className="item-container">
                  <div
                    className="left-aligned-header"
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      marginLeft: "2rem",
                    }}
                  >
                    RANGO HORARIO
                  </div>
                  <div>DIQUES DISPONIBLES</div>
                  <div>CAPACIDAD ASIGNADA POR DIQUE HORA</div>
                  <div>ACCIONES</div>
                </TableHeaderCommonResponsive>
              )}
            <ContainerBodyResponse>
              {loadAppointmentConfiguration.isSuccess &&
                loadAppointmentConfiguration.data.timeslots_by_date.map(
                  (elem: TimeslotsByDateConvert) => {
                    return (
                      <BodyContainerTableCommon
                        className="item-container"
                        height="8rem"
                      >
                        <div
                          className="attribute"
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            height: "100%",
                          }}
                        >
                          <div className="titles">{"RANGO HORARIO"}</div>
                          <div
                            style={{
                              display: "flex",
                              alignItems: "self-start",
                            }}
                          >
                            <div>{dateToRegularFormat(elem.timeslotDate)}</div>
                            <GrayDiv>{`${elem.timeslotStart} - ${elem.timeslotEnd}`}</GrayDiv>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"DIQUES DISPONIBLES"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <div>
                              {elem.docksNum === 1
                                ? "1 dique"
                                : `${elem.docksNum} diques`}
                            </div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">
                            {"CAPACIDAD ASIGNADA POR DIQUE HORA"}
                          </div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <div>
                              {elem.dockCapacity === 1
                                ? "1 cita"
                                : `${elem.dockCapacity} citas`}
                            </div>
                          </div>
                        </div>
                        <div className="attribute" style={{ height: "100%" }}>
                          <div className="titles">{"ACCIONES"}</div>
                          <div className="left-align" style={{ width: "100%" }}>
                            <Authorization
                              actions={[
                                "timeslot-by-date.update_timeslot_by_date",
                              ]}
                            >
                              <EditButton
                                onClick={() => handleClick(elem)}
                                tooltipText="Editar cita"
                              />
                            </Authorization>
                          </div>
                        </div>
                      </BodyContainerTableCommon>
                    );
                  }
                )}
            </ContainerBodyResponse>
          </ContainerGridColumnsTableCommon>
        </ContainerConfigurateCommon>
      </ContainerScrollCommon>
      {loadAppointmentConfiguration.status === "SUCCESS" && (
        <>
          {loadAppointmentConfiguration.data.count > 0 && (
            <div className="flex-paginator">
              <Paginator
                first={
                  (loadAppointmentConfiguration.params.page - 1) *
                  loadAppointmentConfiguration.data.page_size
                }
                rows={loadAppointmentConfiguration.data.page_size}
                totalRecords={loadAppointmentConfiguration.data.count}
                onPageChange={(e) => {
                  const targetPage =
                    e.first / loadAppointmentConfiguration.data.page_size;
                  const pathname = history.location.pathname;
                  const parsedParams = parse(history.location.search);
                  const stringifiedParams = stringify({
                    ...parsedParams,
                    page: targetPage + 1,
                  });
                  history.push(`${pathname}?${stringifiedParams}`);
                }}
              />
            </div>
          )}
        </>
      )}

      {showSidebar ? (
        <AdminAppointmentConfigurationSidebar
          sidebarInfo={sidebarInfo}
          onOutsideClick={() => {
            updateShowSidebar(false);
          }}
          rangeConfirmation={rangeConfirmation}
          isEdit={true}
        />
      ) : null}
    </div>
  );
};
